// extracted by mini-css-extract-plugin
export default {"email-result":"FindEmail_email-result__1QmjI"};